
    /* eslint-disable */

    import Vue from "vue";
    import { AssociationService } from "@/services/AssociationService";
    import { ApplicationSetting } from '../../models/Enums';
    import ApplicationSettingDto from '../../models/api/ApplicationSetting';
    import { SettingService } from "@/services/SettingService";
    import AssociationRegistrationRequest from "@/models/api/association/AssociationRegistrationRequest";
    import Association from "@/models/api/association/Association";
    import AssociationActivity from "@/models/api/association/AssociationActivity";
    import { ActivityService } from "@/services/ActivityService";
    import VuetifyFormMethods from "@/models/vuetify-form-methods";
    import { DataTableHelper } from '@/helpers/DataTableHelper';
    import { AxiosError } from "axios";
    import { SnackbarService } from "@/services/SnackbarService";
    import DeleteDialog from '@/components/dialogs/DeleteDialog.vue';
    import { ValidationHelper } from '@/helpers/ValidationHelper';
    import adaptOrganizationNo from '../../helpers/functions/AdaptOrganizationNo';

    export default Vue.extend({
        components: {
            DeleteDialog
        },
    
        data() {
            return {
                pageHeader: this.$vuetify.lang.t('$vuetify.association.pageHeader'),
                associations: new Array<Association>(),

                associationTableHeaders: [
                    {
                        text: 'association.name',
                        value: 'name'
                    },
                    {
                        text: 'association.orgNo',
                        value: 'organisationNumber'
                    },
                    {
                        text: 'association.externalId',
                        value: 'externalId'
                    },
                    {
                        text: "", value: "actions",
                        width: '15%',
                        
                    },
                    {
                        text: '', value: 'data-table-expand', width: '1%',
                      
                    },
                ],
                isTableLoading: false,

                dialogOpen: false,
                editDialogOpen: false,
                registrationRequest: new AssociationRegistrationRequest("", "", "", []),
                registerAssociationFormValid: false,

                editAssociationRequest: {} as Association,
                showDeleteDialog: false,
                itemToDeleteId: "",
                itemToDeleteName: "",

                rules: {
                    required: (value: any) => !!value || this.$vuetify.lang.t('$vuetify.required'),

                },
                selectedActivities: [] as AssociationActivity[],
                activities: [] as AssociationActivity[],

                associationActivitiesTableHeaders: [

                    { text: "name", value: "name" },
                    { text: 'activity.completeSSNMandatory', value: 'isSSNMandatory', align: "end" },

                ],

               activitiesTableHeadersInExpandable: [

                   { text: "activity.activity", value: "name", sortable: false },
                   { text: 'activity.completeSSNMandatory', value: 'isSSNMandatory', align: "center", sortable: false },                 

                ],


                itemsAddAssociationActivities: [] as AssociationActivity[],
                selectedAddAssociationActivities: [] as AssociationActivity[],

                settingIsSSNMandatory: true,
                settings: new Array<ApplicationSettingDto>(),
                canRegisterAssociationMessage: "",

                expanded: [],               

            };
        },
        created() {
            DataTableHelper.adaptTableHeaders(this.associationTableHeaders, this);
            DataTableHelper.adaptTableHeaders(this.associationActivitiesTableHeaders, this);
            DataTableHelper.adaptTableHeaders(this.activitiesTableHeadersInExpandable, this);
            this.getAssociations();
            this.getIsSSNMandatorySettings();
            this.getCanRegisterAssociation();

        },
        watch: {
            dialogOpen: {
                handler(open: boolean) {
                    if (!open) {
                        (this.$refs.associationForm as VuetifyFormMethods).reset();
                    }
                    else {
                        console.log(this.canRegisterAssociationMessage.length);
                        if (this.canRegisterAssociationMessage.length > 0) {
                            SnackbarService.addErrorMessage(this.canRegisterAssociationMessage);
                            this.$nextTick(() => this.dialogOpen = false);
                            return;
                        }

                        this.getActivities();
                    }
                },
            },
            editDialogOpen: {
                handler(open: boolean) {
                    if (!open) {
                        (this.$refs.editForm as VuetifyFormMethods).reset();
                    }
                },
            },
        },
        computed: {
            computedActivitiesTableHeaders(): any {
                //settingIsSSNMandatory  isSSNMandatory
                return this.activitiesTableHeadersInExpandable.filter((h: any) => !(this.settingIsSSNMandatory && h.value == "isSSNMandatory"));
            },
        },
        methods: {
            fixOrganizationNo() {              
                this.registrationRequest.organisationNumber = adaptOrganizationNo(this.registrationRequest.organisationNumber);
            },
            fixOrganizationNoEdit() {      
              
                this.editAssociationRequest.organisationNumber = adaptOrganizationNo(this.editAssociationRequest.organisationNumber);
            },
            getCanRegisterAssociation(): void {
                AssociationService.CanRegisterAssociation().then(response => {
                    console.log(response);
                    this.canRegisterAssociationMessage = response.data.message;
                    console.log(this.canRegisterAssociationMessage);
                }).catch((error) => {
                    SnackbarService.addErrorMessage(
                        error.response?.data || error.response?.statusText
                    );
                }).finally(() => {
                });
            },
            prepareAssociationEdit(item: Association): void {
                this.$store.commit('addOverlay');
                this.getActivities(item.id);
                AssociationService.GetAssociation(item.id).then(response => {
                    this.editAssociationRequest = response.data;
                    this.editDialogOpen = true;
                }).catch((error) => {
                    SnackbarService.addErrorMessage(
                        error.response?.data || error.response?.statusText
                    );
                }).finally(() => {
                    this.$store.commit('removeOverlay');
                });
            },

            async getActivities(associationId?: number | null) {
                this.$store.commit('addOverlay');
                ActivityService.GetActivitiesAndSelectedAssociationActivities(associationId).then(response => {
          
                    this.activities = response.data;                 
                    this.selectedActivities = this.activities.filter(activity => activity.id > 0)                   

                }).catch((error) => {
                    SnackbarService.addErrorMessage(
                        error.response?.data || error.response?.statusText
                    );
                })
                .finally(() => {
                    this.$store.commit('removeOverlay');
                });

            },


            async registerAssociation(request: AssociationRegistrationRequest) {

                request.associationActivities = this.selectedActivities;
                AssociationService.RegisterAssociation(request).then(
                    (result) => {
                        //console.log(result);

                        this.getAssociations();                       
                        this.dialogOpen = false;

                        SnackbarService.addSuccessMessage(result?.data);
                    },
                    (error: AxiosError) => {
                        SnackbarService.addErrorMessage(
                            error.response?.data || error.response?.statusText
                        );
                    }
                );
            },
            async removeAssociation(id: number) {
                this.showDeleteDialog = false;

                if (id != null) {
                    AssociationService.RemoveAssociation(id).then(
                        (result) => {
                            SnackbarService.addSuccessMessage(result?.data);

                           // console.log(result);
                            this.getAssociations();
                        },
                        (error: AxiosError) => {
                         //   console.log(error);

                            SnackbarService.addErrorMessage(
                                error.response?.data || error.response?.statusText
                            );
                        }
                    );
                }
            },
            async editAssociation(itemToUpdate: Association) {

                itemToUpdate.associationActivities = this.selectedActivities;
                AssociationService.EditAssociation(itemToUpdate).then(
                    (result) => {
                        //console.log(result);
                        SnackbarService.addSuccessMessage(result?.data);
                        this.getAssociations();
                     
                        this.editDialogOpen = false;
                    },
                    (error: AxiosError) => {
                        SnackbarService.addErrorMessage(
                            error.response?.data || error.response?.statusText
                        );
                    }
                );
            },
            async getAssociations() {
                this.isTableLoading = true;

                this.associations = (await AssociationService.GetAssociations()).data;

                this.isTableLoading = false;
            },
            async getIsSSNMandatorySettings() {
                SettingService.GetSettingsByKeyNames("IsSSNMandatory").then(
                    (result) => {
                        this.settings = result.data;
                        this.settingIsSSNMandatory = JSON.parse(this.settings[this.getApplicationSetting(ApplicationSetting.IsSSNMandatory)].value.toString().toLowerCase());
                    })
            },

            getApplicationSetting(app: ApplicationSetting) {
                return this.settings.findIndex((val: any) => val.keyName == app);
            },
            // rules
            uniqueAssociationName(value: string): string | boolean {
                if (
                    value &&
                    this.associations.findIndex(
                        (x) => x.name.trim().toLocaleLowerCase() == value.toLocaleLowerCase()
                    ) > -1
                ) {
                    
                    return this.$vuetify.lang.t('$vuetify.association.nameAlreadyExists') + " " + value;                  
                }

                return true;
            },
            // rules
            uniqueAssociationOrgNo(value: string): string | boolean {
                if (
                    value &&
                    this.associations.findIndex(
                        (x) =>
                            x.organisationNumber.trim().toLocaleLowerCase() ==
                            value.toLocaleLowerCase()
                    ) > -1
                ) {
                    return this.$vuetify.lang.t('$vuetify.association.orgNoAlreadyExists') + " " + value;                   
                }

                return true;
            },
            // rules
            uniqueAssociationExternalId(value: string): string | boolean {
                if (
                    value &&
                    this.associations.findIndex(
                        (x) =>
                            x.externalId.trim().toLocaleLowerCase() ==
                            value.toLocaleLowerCase()
                    ) > -1
                ) {
                    return this.$vuetify.lang.t('$vuetify.association.externalIdAlreadyExists') + " " + value;
                }

                return true;
            },
            uniqueAssociationNameEdit(value: string): string | boolean {
                // Filter new name except from the item being edited.
                var item = this.editAssociationRequest;
                if (
                    value &&
                    this.associations
                        .filter((x) => x.id != item.id)
                        .findIndex(
                            (f) =>
                                f.name.trim().toLocaleLowerCase() ==
                                value.trim().toLocaleLowerCase()
                        ) > -1
                ) {
                    return this.$vuetify.lang.t('$vuetify.association.nameAlreadyExists') + " " + value;
                }

                return true;
            },
            uniqueAssociationOrgNoEdit(value: string): string | boolean {
                var item = this.editAssociationRequest;
                // Filter organizationnumber except from the item being edited.
                if (
                    value &&
                    this.associations
                        .filter((x) => x.id != item.id)
                        .findIndex(
                            (f) =>
                                f.organisationNumber.trim().toLocaleLowerCase() ==
                                value.trim().toLocaleLowerCase()
                        ) > -1
                ) {
                    return this.$vuetify.lang.t('$vuetify.association.orgNoAlreadyExists') + " " + value;                 
                }

                return true;
            },
            uniqueAssociationExternalIdEdit(value: string): string | boolean {
                var item = this.editAssociationRequest;
                // Filter externalId except from the item being edited.
                if (
                    value &&
                    this.associations
                        .filter((x) => x.id != item.id)
                        .findIndex(
                            (f) =>
                                f.externalId.trim().toLocaleLowerCase() ==
                                value.trim().toLocaleLowerCase()
                        ) > -1
                ) {
                    return this.$vuetify.lang.t('$vuetify.association.externalIdAlreadyExists') + " " + value;
                }

                return true;
            },
            checkValidOrgNo(value: string): string | boolean {

                if (value != null) {
                  
                    var isValid = ValidationHelper.Mod10CheckSocialSecurityOrganizationNumber(value);
                    if (!isValid) {
                        return this.$vuetify.lang.t('$vuetify.invalidOrgNo');
                    }
                }
                return true;
            },
        },
    });
